import { ref } from 'vue';
export default {
  setup() {
    const active = ref(0);
    return {
      active
    };
  }
};